import { createSlice } from '@reduxjs/toolkit'

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    role: undefined,
  },
  reducers: {
    setRole: (state, action) => {
      const login = action.payload
      return {
        ...state,
        role: login

      }
    },
    setAdmin: (state, action) => {
      const admin = action.payload
      return {
        ...admin,
      }
    }
  }
})

export const { setRole, setAdmin } = loginSlice.actions
export default loginSlice.reducer
